export default "__VITE_ASSET__DLUG3dAg__"